module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_diamond_darkbrown.841d78b5.png";